import React, { useEffect, useState } from 'react'
import Footer from '../components/footer/Footer';
import useStyles from '../styles/checking_accout';
import { styled } from '@mui/system'
import * as ROUTES from '../constants/routes'
import { Grid } from '@mui/material';
import { CiMoneyCheck1 } from "react-icons/ci";
import Popup from '../components/appbar/Popup';
import { Link } from 'react-router-dom';


const HolidayScheduleContainer: React.FC = () => {
    const classes = useStyles()

    useEffect(() => {
        const sectionEl = document.getElementById("checking-account-hero")
        const handleScroll = () => {
            const position = 217.168 + window.scrollY * 0.65
            if(sectionEl){
                if(position >= 500){
                    sectionEl.style.backgroundPosition = `0px -500px`
                }else{
                    sectionEl.style.backgroundPosition = `0px -${position}px`
                }
            }
            
        };
    
        window.addEventListener('scroll', handleScroll);
    
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);
    const Hero = styled('section')(({ theme }) => ({
        position: 'relative',
        backgroundImage: 'url(imgs/checking_accounts.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: '0px -217.168px',
        padding: '150px 0px',
        top: '-100px',
        marginBottom: '-100px',
        textShadow: 'none !important',
        borderBottom: 'none',
        backgroundColor: 'transparent',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        transition: 'all 0.17s linear !important',

        [theme.breakpoints.down('md')]: {
            padding: '100px 0px',
        },
        [theme.breakpoints.down('md')]: {
            padding: '60px 0px',
        },
    }));
    const MainContent = styled('section')(({ theme }) => ({
        position: 'relative',
        overflow: 'hidden',
        background: '#fff',
        margin: '0',
    }));

    const [needed, setNeeded] = useState<boolean>(false)
    const [name, setName] = useState<string>('')

    const handleLessLink = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault()

        setName('checking_accounts_less')
        setNeeded(true)
    }
    
    const handleStreetLink = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault()

        setName('main_street_check')
        setNeeded(true)
    }
  return (
    <>
        <main>
            <Hero id='checking-account-hero'>
                <div className={classes.heroInner}>
                    <h1 className={classes.heroInnerH1}>Checking Accounts</h1>
                </div>
            </Hero>

            <MainContent>
                <div className={classes.mainContentInner}>
                        <div className={classes.mainContentInnerContainer}>
                            <div style={{clear: 'both', float: 'none', paddingRight: '0', position: 'relative', width: '100%'}}>
                                <div className={classes.pageTitle}>
                                    <h2 className={classes.pageTitleH2}>Share Draft (Checking) Accounts</h2>
                                </div>

                                <p className={classes.paragraph} style={{marginBottom: '2rem'}}>A Credit Union Share Draft account is an alternative to a traditional checking account at a bank and offers you the savings and convenience you want to manage your personal day-to-day finances.</p>
                                <p className={classes.paragraph} style={{marginBottom: '2rem'}}>There is no minimum balance, no per check charge and no monthly service fee. The only thing you pay for is the printing of your choice of drafts when you need them.</p>
                                <p className={classes.paragraph} style={{marginBottom: '2rem'}}>You'll receive a monthly statement so you may reconcile your check register accordingly and Overdraft Protection and Courtesy Pay is available.</p>


                                <div>
                                    <a className={classes.linkBtn} style={{display: 'inline'}} href={ROUTES.CONTACT_US}>Contact our Office</a>
                                    <p className={classes.paragraph} style={{display: 'inline'}}>today to open your Credit Union Share Draft Account!</p>
                                </div>

                                
                                <div style={{margin: '80px 0'}}>
                                    <div className={classes.pageTitle}>
                                        <h2 className={classes.pageTitleH2}>Reorder Checks</h2>
                                    </div>
                                    <p className={classes.paragraph} style={{marginBottom: '2rem'}}>Reordering checks online has never been easier. Choose a check provider and submit your reorder below.</p>



                                    <Grid container style={{justifyContent: 'space-between'}}>
                                        <Grid item xs={12} sm={5.65}>
                                            <div id='card-holder' className={classes.pageCard}>
                                                <div id='card-icon-holder' className={classes.cardIconHolder}>
                                                    <div id='card-icon-icon' className={classes.cardIcon}>
                                                        <CiMoneyCheck1 style={{fontSize: '3rem'}}/>
                                                    </div>
                                                </div>
                                                <h3 className={classes.cardH3}>Checks For Less</h3>
                                                <h3 className={classes.cardH3}>
                                                    <Link className={classes.cardLink} onClick={(e)=>handleLessLink(e)} to='https://www.bank-a-count.com/Account/Orders/Checks/OrderChecks/Consumer/SignIn.asp?RTNum=271985556'>Reorder Checks</Link>
                                                </h3>
                                            </div>
                                        </Grid>
                                        <Grid item xs={12} sm={5.65}>
                                            <div id='card-holder2' className={classes.pageCard}>
                                                <div id='card-icon-holder2' className={classes.cardIconHolder}>
                                                    <div id='card-icon-icon2' className={classes.cardIcon}>
                                                        <CiMoneyCheck1 style={{fontSize: '3rem'}}/>
                                                    </div>
                                                </div>
                                                <h3 className={classes.cardH3}>Main Street Checks</h3>
                                                <h3 className={classes.cardH3}>
                                                    <Link className={classes.cardLink} onClick={(e)=>handleStreetLink(e)} to='https://www.leghrefacymemberservices.net/LOES/main/interfacewww.aspx?UseHeader=Yes'>Reorder Checks</Link>
                                                </h3>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>


                                
                        
                            </div>
                        </div>
                </div>


            </MainContent>

    


            <Footer />
        </main>
        <Popup needed={needed} setNeeded={setNeeded} name={name} setName={setName}/>
    </>
  )
}

export default HolidayScheduleContainer
